var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rexer_reservation", attrs: { id: _vm.reservation.id } },
    [
      _vm._v("\n  " + _vm._s(_vm.dataEvent.contact_form_id) + "\n  "),
      _c("div", { staticClass: "rexer_reservation_form" }, [
        _c("div", { staticClass: "rexer_reservation_form__inner" }, [
          _c("div", { staticClass: "rexer_reservation_form__row" }, [
            _c("h4", { staticClass: "rexer_reservation_form__title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.reservation.event_title) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "rexer_reservation_form__subtitle" }, [
              _vm._v(_vm._s(_vm.reservation.event_location))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "rexer_reservation_form__subtitle" }, [
              _vm._v(
                _vm._s(
                  _vm._f("moment")(
                    _vm.reservation.event_date,
                    "DD.MM.YY, HH.mm"
                  )
                ) + " UHR"
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "rexer_reservation_form__row is-flex show-3" },
            [
              _c(
                "div",
                { staticClass: "rexer_reservation_form__control is-first" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.reservation.tickets,
                        expression: "reservation.tickets"
                      }
                    ],
                    staticClass: "control",
                    attrs: {
                      type: "text",
                      name: "tickets",
                      value: "",
                      min: "1",
                      max: "10",
                      "aria-invalid": "false",
                      placeholder: "Anzahl Tickets*"
                    },
                    domProps: { value: _vm.reservation.tickets },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.reservation,
                          "tickets",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.submitted && !_vm.$v.reservation.tickets.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.error.required) +
                            "\n          "
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "rexer_reservation_form__control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.reservation.vorname,
                      expression: "reservation.vorname",
                      modifiers: { trim: true }
                    }
                  ],
                  staticClass: "control",
                  attrs: {
                    type: "text",
                    name: "vorname",
                    value: "",
                    placeholder: "Vorname*"
                  },
                  domProps: { value: _vm.reservation.vorname },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.reservation,
                        "vorname",
                        $event.target.value.trim()
                      )
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.submitted && !_vm.$v.reservation.vorname.required
                  ? _c("div", { staticClass: "error" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.error.required) +
                          "\n          "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "rexer_reservation_form__control is-last" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.reservation.name,
                        expression: "reservation.name",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "control",
                    attrs: {
                      type: "text",
                      name: "name",
                      value: "",
                      placeholder: "Name*"
                    },
                    domProps: { value: _vm.reservation.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.reservation,
                          "name",
                          $event.target.value.trim()
                        )
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.submitted && !_vm.$v.reservation.name.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.error.required) +
                            "\n          "
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "rexer_reservation_form__row is-flex show-2" },
            [
              _c("div", { staticClass: "rexer_reservation_form__control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.reservation.firma,
                      expression: "reservation.firma",
                      modifiers: { trim: true }
                    }
                  ],
                  staticClass: "control",
                  attrs: {
                    type: "text",
                    name: "firma",
                    value: "",
                    placeholder: "Firma"
                  },
                  domProps: { value: _vm.reservation.firma },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.reservation,
                        "firma",
                        $event.target.value.trim()
                      )
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "rexer_reservation_form__control is-last" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.reservation.strasse,
                        expression: "reservation.strasse",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "control",
                    attrs: {
                      type: "text",
                      name: "strasse",
                      value: "",
                      placeholder: "Strasse/Nr*"
                    },
                    domProps: { value: _vm.reservation.strasse },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.reservation,
                          "strasse",
                          $event.target.value.trim()
                        )
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.submitted && !_vm.$v.reservation.strasse.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.error.required) +
                            "\n          "
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "rexer_reservation_form__row is-flex show-2" },
            [
              _c("div", { staticClass: "rexer_reservation_form__control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.reservation.plz,
                      expression: "reservation.plz",
                      modifiers: { trim: true }
                    }
                  ],
                  staticClass: "control",
                  attrs: {
                    type: "text",
                    name: "plz",
                    value: "",
                    placeholder: "PLZ/Ort*"
                  },
                  domProps: { value: _vm.reservation.plz },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.reservation,
                        "plz",
                        $event.target.value.trim()
                      )
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.submitted && !_vm.$v.reservation.plz.required
                  ? _c("div", { staticClass: "error" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.error.required) +
                          "\n          "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "rexer_reservation_form__control is-last" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.reservation.telefon,
                        expression: "reservation.telefon",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "control",
                    attrs: {
                      type: "text",
                      name: "telefon",
                      value: "",
                      placeholder: "Telefon*"
                    },
                    domProps: { value: _vm.reservation.telefon },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.reservation,
                          "telefon",
                          $event.target.value.trim()
                        )
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.submitted && !_vm.$v.reservation.telefon.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.error.required) +
                            "\n          "
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "rexer_reservation_form__row" }, [
            _c("div", { staticClass: "rexer_reservation_form__control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.reservation.email,
                    expression: "reservation.email",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "control",
                attrs: {
                  type: "email",
                  name: "email",
                  value: "",
                  placeholder: "Email*"
                },
                domProps: { value: _vm.reservation.email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.reservation,
                      "email",
                      $event.target.value.trim()
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              _vm._v(" "),
              _vm.submitted && !_vm.$v.reservation.email.required
                ? _c("div", { staticClass: "error" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.error.required) +
                        "\n          "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.submitted && !_vm.$v.reservation.email.email
                ? _c("div", { staticClass: "error" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.error.email) +
                        "\n          "
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "rexer_reservation_form__row" }, [
            _c("div", { staticClass: "rexer_reservation_form__control" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.reservation.mitteilung,
                    expression: "reservation.mitteilung"
                  }
                ],
                staticClass: "control is-textarea",
                attrs: { placeholder: "Mitteilung" },
                domProps: { value: _vm.reservation.mitteilung },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.reservation, "mitteilung", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "rexer_reservation_form__row" }, [
            _c(
              "div",
              { staticClass: "rexer_reservation_form__control is-submit" },
              [
                _c(
                  "button",
                  {
                    staticClass: "rexer_reservation_form__btn",
                    attrs: { title: "Senden" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.submitHandle($event)
                      }
                    }
                  },
                  [
                    _c("span", [_vm._v("Senden")]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "arrow-right",
                      domProps: { innerHTML: _vm._s(_vm.arrow_right) }
                    })
                  ]
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rexer_reservation_message" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.isError) +
              "\n      " +
              _vm._s(_vm.submitStatus) +
              "\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "rexer_reservation_close",
          attrs: { href: "#", title: "Back" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.backHandle($event)
            }
          }
        },
        [
          _c("i", {
            staticClass: "close-btn",
            domProps: { innerHTML: _vm._s(_vm.close_btn) }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }